import { Injectable } from '@angular/core';
import * as CryptoJS from 'crypto-js';

@Injectable()
export class AesService {

  // private SECRET_CODE: string ;
  private readonly SECRET_CODE: string = '1234567891234567';
  private keySize: number = 128 / 32;
  private iterationCount = 1000;
  // private  iv: string  ;
  // private salt: string ;
  private pwdEncrypted: string;

  // private cipherText: string;

  constructor() {
  }

  public generateKey(salt: string) {

    // this.SECRET_CODE = sessionStorage.getItem('_uniqueKey');
    const key = CryptoJS.PBKDF2(
      this.SECRET_CODE,
      CryptoJS.enc.Hex.parse(salt),
      {keySize: this.keySize, iterations: this.iterationCount});

    return key;
  }

  public encrypt(planText: string) {
    const iv = CryptoJS.lib.WordArray.random(16).toString(CryptoJS.enc.Hex);
    const salt = CryptoJS.lib.WordArray.random(16).toString(CryptoJS.enc.Hex);

    const key = this.generateKey(salt);

    const encrypted = CryptoJS.AES.encrypt(planText, key, {iv: CryptoJS.enc.Hex.parse(iv)});

    const cipherText = encrypted.ciphertext.toString(CryptoJS.enc.Base64);

    const aesPassword = (iv + '::' + salt + '::' + cipherText);
    // conversion en base 64
    this.pwdEncrypted = btoa(aesPassword);

    return this.pwdEncrypted;
  }

}
